import { PureComponent } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import {
  VEHICLE_NAME,
  MODEL_NAME,
  MAKE_NAME,
} from 'components/searchAds/constants';
import formValues from 'helpers/form/formValues';
import {
  vehiclePropTypes,
  vehicleDefaultProps,
  FIELD_INDEX,
} from '../../constants';
import ModelControl from '../Control';
import mapStateToProps from './mapStateToProps';

class ModelField extends PureComponent {
  static propTypes = {
    ...vehiclePropTypes,
  };

  static defaultProps = {
    ...vehicleDefaultProps,
    component: ModelControl,
    label: __('filterBlocks.titles.model'),
  };

  render() {
    const { fieldIndex } = this.props;

    return (
      <Field
        {...this.props}
        name={`${VEHICLE_NAME}.${fieldIndex}.${MODEL_NAME}`}
      />
    );
  }
}

export default formValues(({ fieldIndex = FIELD_INDEX }) => ({
  makeValue: `${VEHICLE_NAME}.${fieldIndex}.${MAKE_NAME}`,
}))(connect(mapStateToProps)(ModelField));
